// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2de4h","logo":"Header_logo__3Ds7o","truck":"Header_truck__2TNBV"};